// bill_subsystem_v1: dedicated axios instance for bill app
// - Uses separate localStorage key 'bill_token' to not conflict with chat
// - Auto-attaches Authorization header
// - Auto-redirects to /bill-login on 401
import axios from 'axios';

const API = axios.create({ baseURL: '' });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('bill_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const code = err.response?.data?.code;
    if (status === 401 || code === 'SESSION_REPLACED' || code === 'BILL_USER_NOT_FOUND') {
      try { localStorage.removeItem('bill_token'); } catch (e) {}
      try { localStorage.removeItem('bill_user'); } catch (e) {}
      // Only redirect if we are inside the bill app (avoid infinite loop on login page)
      if (typeof window !== 'undefined' && window.location.pathname !== '/' && !window.location.pathname.startsWith('/bill-login')) {
        window.location.href = '/';
      }
    }
    // bill_expiry_fe_v1: บิลหมดอายุ -> แจ้งเตือน + กลับหน้า login
    if (code === 'BILL_EXPIRED') {
      try {
        if (typeof window !== 'undefined' && !window.__billExpiredNotified) {
          window.__billExpiredNotified = true;
          alert('ระบบบิลหมดอายุแล้ว กรุณาต่ออายุ • ติดต่อแอดมิน @mawin1991');
        }
      } catch (e) {}
      try { localStorage.removeItem('bill_token'); localStorage.removeItem('bill_user'); } catch (e) {}
      if (typeof window !== 'undefined' && window.location.pathname !== '/' && !window.location.pathname.startsWith('/bill-login')) {
        window.location.href = '/';
      }
    }
    return Promise.reject(err);
  }
);

export default API;
